// extracted by mini-css-extract-plugin
export var tosLink = "_be-0";